import axios from 'axios';
import { BranchI } from 'models/branch';
import { ENDPOINTS } from 'utils/constants/endpoint';

export const fetchBranches = async () =>
  await axios.get<BranchI[]>(`${ENDPOINTS.sa}/branches`).then((resp) => resp.data);
